import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy() {
    this.writeText(this.textValue).then(() => {
      this.element.textContent = "Copied"
    })
  }

  writeText(text) {
    if (navigator.clipboard?.writeText) {
      return navigator.clipboard.writeText(text)
    }

    return this.writeTextWithTextarea(text)
  }

  writeTextWithTextarea(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.top = "0"
    textarea.style.left = "0"
    textarea.style.opacity = "0"

    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()

    try {
      document.execCommand("copy")
      return Promise.resolve()
    } finally {
      textarea.remove()
    }
  }
}
